

// import { clientResolver } from './shared/resolvers/client-resolver';

const Profile = () => import('@/app/views/clientes/views/client-profile/ClientProfile');

const Account = () => import('@/app/views/clientes/views/client-profile/ClientAccount');
const ContactPerson = () => import('@/app/views/clientes/views/client-contact-person/ClientContactPerson');
const ContactBillingData = () => import('@/app/views/clientes/views/client-billing-data/ClientBillingData');
const PaymentMethod = () => import('@/app/views/clientes/views/client-payment-method/ClientPaymentMethod');
const Loyalty = () => import('@/app/views/clientes/views/client-loyalty/ClientLoyalty');
// const Notification = () => import('@/app/views/clientes/views/client-notification/ClientNotification');


const clientSettingsRoutes = [
  {
    //// Configuración
    path: "configuracion",
    redirect: "/configuracion/mi-cuenta",
    name: "Configuración",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "/configuracion/personal-info",
        name: "Datos personales",
        component: Profile,
        meta: {
          auth: true
        }
      },

      {
        path: "/configuracion/mi-cuenta",
        name: "Mi Cuenta",
        component: Account, //Profile,
        meta: {
          auth: true
        }
      },
      {
        path: "/configuracion/datos-contacto",
        name: "Persona de Contacto",
        component: ContactPerson,
        meta: {
          auth: true
        }
      },
      {
        path: "/configuracion/datos-factura",
        name: "Datos de Facturación",
        component: ContactBillingData,
        meta: {
          auth: true
        }
      },
      {
        path: "/configuracion/metodo-pago",
        name: "Métodos de Pago",
        component: PaymentMethod,
        meta: {
          auth: true
        }
      },
      // {
      //   path: "/configuracion/fidelizacion",
      //   name: 'Fidelización',
      //   component: Loyalty,
      //   meta: {
      //     auth: true
      //   }
      // }
    ]
  }






]


export default clientSettingsRoutes;
